import React, {Component} from 'react';
import {
    List,
    Card,
    Divider,
    Row,
    Col,
    Icon,
    Button,
} from 'antd';
import {Route, Switch, Redirect, NavLink, matchPath, Link} from 'react-router-dom';
import NonEngineer from './NonEngineer';

class NonEngineers extends Component {
    componentDidMount() {
        const {belongsTo, fetchNonEngineers} = this.props;
        return fetchNonEngineers(belongsTo);
    }
    render() {
        const {data, isFetching} = this.props.engineers;
        const {
            match,
            location: {pathname},
            belongsTo,
            settings,
            updateNonEngineer,
            uploadNonEngineerDocument,
            deleteNonEngineerDocument,
            NewNonEngineer,
            generateDocUrl,
            branches
        } = this.props;
        const generateUrl = (nonEngineer, file) => generateDocUrl(belongsTo, nonEngineer, file);
        const renderItem = item => {
            if (isFetching) return null;

            const {id, full_name} = item;
            const matchLocation = matchPath(pathname, {path: `${match.url}/:id`});
            const itemActive = matchLocation && (+matchLocation.params.id === item.id);

            const description = () => (
                <span>
                    Telephone: {item.phone_number || 'Not Available'}
                    <Divider type="vertical" />
                    Email: {item.email || 'Not Available'}
                </span>
            );

            return (
                <List.Item className={itemActive ? 'active' : ''} style={{paddingLeft: 12, paddingRight: 12}}>
                    <List.Item.Meta
                        title={<NavLink to={`${match.url}/${id}`}>{`${full_name}`}</NavLink>}
                        description={description()}
                    />
                </List.Item>
            );
        };
        const onUpdate = engineer => fields => {
            return updateNonEngineer(belongsTo, engineer, fields);
        };
        const handleUpload = (engineer) => ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });
            formData.append(filename, file);

            return uploadNonEngineerDocument(belongsTo, engineer, formData).then(() => {
                const {uploadError} = this.props.engineers.data.find(d => d.id === engineer);
                if (!uploadError) {
                    file.status = 'done';
                    return onSuccess(file);
                }

                const {res: {errors, message}} = uploadError;
                file.status = 'error';
                file.response = message;
                return onError(file);
            });
        };
        const onDelete = (engineer) => (doc) => {
            return deleteNonEngineerDocument(belongsTo, engineer, doc.uid);
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>Non Gas Safe Engineers</span>
            </div>
        );
        const extra = () => {
            return (
                <Button>
                    <Link to={`${match.url}/new`}><Icon type="plus"/> New Non Gas Engineer</Link>
                </Button>
            );
        };
        return (
            <Card title={title()} loading={isFetching} bordered={false} extra={extra()}>
                <Row gutter={16}>
                    <Col md={{span: 12}}>
                        <List
                            itemLayout="horizontal"
                            dataSource={data.filter(i => !i.draft)}
                            renderItem={renderItem}
                        />
                    </Col>
                    <Col md={{span: 12}}>
                        <Switch>
                            <Route exact path={`${match.url}/new`} component={NewNonEngineer} />
                            <Route path={`${match.url}/:id`} render={props => {
                                if (isFetching || !data.length) return null;

                                const {match: {params: {id}}} = props;
                                const engineer = data.find(i => i.id === +id);

                                return <NonEngineer
                                    {...props}
                                    engineer={engineer}
                                    settings={settings}
                                    onUpdate={onUpdate(engineer.id)}
                                    onUpload={handleUpload(engineer.id)}
                                    onDelete={onDelete(engineer.id)}
                                    generateUrl={generateUrl}
                                    branches={branches}
                                />;
                            }} />
                            {data.length ? <Redirect from={`${match.url}`} to={`${match.url}/${data[0].id}`}/> : null}
                        </Switch>
                    </Col>
                </Row>
            </Card>
        );
    }
}

export default NonEngineers;


// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/NonEngineers.js